import { Icon } from '@/icons/icon'
import Link from 'next/link'
import { useLogin } from '../account/context/use-login'

export const AftershipBreadcrumb = () => {
  const { loggedIn } = useLogin()

  return (
    <Link href={loggedIn ? '/account/orders' : '/aftership'} prefetch={false}>
      <div className='flex cursor-pointer items-center whitespace-nowrap max-md:mr-2'>
        <Icon
          className='mr-1 md:mr-2'
          name='shipment-tracking-regular'
          color='light'
          variant='dark'
          size='ml'
        />
        <p className='leading-[18px] text-primary-contrast-text hover:underline max-md:text-xs'>
          Track Order
        </p>
      </div>
    </Link>
  )
}
